export default ({ app }) => {
  if (process.client) {
    const script = document.createElement('script')
    script.innerHTML = 'LA.init({ id: "3FoQKzCmOgbp773S", ck: "3FoQKzCmOgbp773S" })'
    document.head.appendChild(script)
  }
}
